import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../helper/axiosIntance';
import apiZalo from '../../api/zalo';
import apiFacebook from '../../api/facebook';
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  contacts: [],
  contactFromEvents: {}
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CONTACT SSUCCESS
    getNewMessageSuccess(state, action) {
      const contact = action.payload;
      if (state.contacts.length > 0) {
        var is_exits = false;
        state.contacts.map((item, index) => {
          if ((item.to_id === contact.to_id && item.from_id === contact.from_id) || (item.to_id === contact.from_id && item.from_id === contact.to_id)) {
            is_exits = true;
          }
        });
        if (!is_exits) {
          const contactNew = { ...contact, is_show: true };
          state.contacts.push(contactNew);
        }
      } else {
        state.contacts.push(contact);
      }

    },
    getNewMessageSelectedSuccess(state, action) {

      const contact = action.payload;
      if (state.contacts.length > 0) {
        var is_exits = false;
        state.contacts.map((item, index) => {
          if ((item.to_id === contact.to_id && item.from_id === contact.from_id) || (item.to_id === contact.from_id && item.from_id === contact.to_id)) {
            is_exits = true;
          }
        });
        if (!is_exits) {
          const contactNew = { ...contact, is_show: true };
          state.contacts.push(contactNew);
          state.contactFromEvents = contactNew;
        }
      } else {
        const contactNew = { ...contact, is_show: true };
        state.contacts.push(contactNew);
        state.contactFromEvents = contactNew;
      }

    },
    statusRemoveContactEvent(state, action) {
      const infoContact = action.payload;

      state.contactFromEvents = {};
      const list_chat = state.contacts.filter((item) => infoContact.uid !== item.to_id && infoContact.uid !== item.from_id);
      state.contacts = list_chat;

    }
  }
});

// Reducer
export default slice.reducer;

// Actions
//export const { addRecipients, onSendMessage, resetActiveConversation } = slice.actions;

// ----------------------------------------------------------------------

export function newMessageZalo(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const check_new_message_permission = apiZalo
      dispatch(slice.actions.getNewMessageSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function newMessageFacebook(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log(params)
      dispatch(slice.actions.getNewMessageSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function newMessageZaloBySelectedContact(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const check_new_message_permission = apiZalo.checkPermissionMessage(params);
      dispatch(slice.actions.getNewMessageSelectedSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function newMessageFacebookBySelectedContact(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const check_new_message_permission = apiZalo.checkPermissionMessage(params);
      dispatch(slice.actions.getNewMessageSelectedSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function removeContactEvent(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusRemoveContactEvent(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------
